import React from "react";
import classes from "./AiAnalysis.module.css";
import { Text } from "components/common";
import Devider from "components/common/Devider/Devider";

const AiAnalysis = () => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <Text lg medium primitive50>
          AI Analysis
        </Text>
        <Devider />
      </div>
      <div className={classes.content}>
        <Text textCenter primitive300>
          No Content Available
        </Text>
      </div>
    </div>
  );
};

export default AiAnalysis;
